import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'convertSexo' })
export class ConvertSexoPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value === 'f' || value === 'F') {
      return 'Feminino';
    } else if (value === 'm' || value === 'M') {
      return 'Masculino';
    }
    return 'Ambos';
  }
}
